module.exports = __webpack_public_path__ + "img/feedback.ecff5478.svg";